import DOMPurify from 'dompurify';

// Central place to turn untrusted HTML into something safe to feed
// dangerouslySetInnerHTML. Two profiles:
//   - sanitizeEmailHtml: broad (inbound email needs tables/images/styling)
//   - sanitizeMarkdownHtml: tight (our own tiny markdown -> a/strong/em/…)
// Both strip <script>, on* handlers, and dangerous URL schemes
// (javascript:, data:, vbscript:) — DOMPurify does this by default; the
// configs below only narrow what's allowed, never widen it.

// Force every surviving link to open safely and not leak the opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Inbound email is authored by external, unauthenticated senders. Allow the
// formatting real emails use, but no active content or embedding.
export const sanitizeEmailHtml = (html) =>
  DOMPurify.sanitize(html == null ? '' : String(html), {
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'link', 'base', 'meta'],
    FORBID_ATTR: ['srcset'],
    ALLOW_DATA_ATTR: false,
  });

// Output of parseMarkdown — only the handful of tags that helper emits.
export const sanitizeMarkdownHtml = (html) =>
  DOMPurify.sanitize(html == null ? '' : String(html), {
    ALLOWED_TAGS: ['a', 'strong', 'em', 'b', 'i', 'br', 'span', 'p', 'li', 'ul', 'ol', 'h3', 'h4', 'h5', 'code'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    ALLOW_DATA_ATTR: false,
  });
